import { notesReqApprovalActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
    loading: false,
    approving: false,
    rejectVisible: false
};

export const reducer = createReducer(initialState, {
    [notesReqApprovalActions.setSelectedMessage]: (state, action) => {
        state.selectedMessage = action.payload.noteId;
        state.rejectVisible = false;
    },
    [notesReqApprovalActions.markReadFailure]: (state, action) => {
        log.error('Error marking note as read. noteId: ' + action.payload.noteId + ' error: ' + action.payload.error);
    },
    [notesReqApprovalActions.loadRequest]: (state, action) => {
        state.loading = true;
    },
    [notesReqApprovalActions.loadSuccess]: (state, action) => {
        state.loading = false;
    },
    [notesReqApprovalActions.loadFailure]: (state, action) => {
        state.loading = false;
        log.error('Error loading notes req. approval. error: ' + action.payload.error);
    },
    [notesReqApprovalActions.approveAllRequest]: (state, action) => {
        state.approving = true;
    },
    [notesReqApprovalActions.approveAllSuccess]: (state, action) => {
        state.selectedMessage = undefined;
        state.approving = false;
    },
    [notesReqApprovalActions.approveAllFailure]: (state, action) => {
        state.approving = false;
        log.error('Error approving all notes: ' + action.payload.noteIds.join(', ') + ' error: ' + action.payload.error);
    },
    [notesReqApprovalActions.approveSuccess]: (state, action) => {
        state.selectedMessage = undefined;
    },
    [notesReqApprovalActions.approveFailure]: (state, action) => {
        state.approving = false;
        log.error('Error approving noteId: ' + action.payload.noteId + ' error: ' + action.payload.error);
    },
    [notesReqApprovalActions.rejectSuccess]: (state, action) => {
        state.selectedMessage = undefined;
        state.rejectVisible = false;
    },
    [notesReqApprovalActions.rejectFailure]: (state, action) => {
        log.error('Error rejecting noteId: ' + action.payload.noteId + ' error: ' + action.payload.error);
    },
    [notesReqApprovalActions.toggleReject]: (state, action) => {
        state.rejectVisible = !state.rejectVisible;
    }

})


